"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
const _contracts_1 = require("../../_contracts");
const _filters_1 = require("../../_filters");
let Editor = class Editor extends vue_property_decorator_1.Vue {
    /**
     * Determines icon name.
     */
    iconName(key) {
        return `${key}-fill`;
    }
    /**
     * Determines uniq link id.
     */
    linkId(index) {
        return `link-${index}`;
    }
    /**
     * Determines editor links.
     */
    get links() {
        const links = this.editor.links;
        if (!links) {
            return;
        }
        return Object.entries(links).filter(([key, value]) => !!value);
    }
    /**
     * Determines editor author
     * avatar image.
     *
     */
    get authorAvatar() {
        if (typeof this.editor === 'undefined' || typeof this.editor.avatar === 'undefined') {
            return;
        }
        return _filters_1.prepareImage(this.editor.avatar, _contracts_1.ImageRatio.Square, 510, this.isLazy);
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], Editor.prototype, "editor", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false,
        default: 'h3'
    }),
    __metadata("design:type", String)
], Editor.prototype, "nameTag", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: true
    }),
    __metadata("design:type", Boolean)
], Editor.prototype, "isLazy", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: true
    }),
    __metadata("design:type", Boolean)
], Editor.prototype, "showAbout", void 0);
Editor = __decorate([
    vue_property_decorator_1.Component({
        name: 'Editor',
        components: {
            BootstrapImage: front_1.BootstrapImage,
            BootstrapIcon: front_1.BootstrapIcon
        },
        template: `
    <div class="editor row m-0">

    <div class="editor__avatar col-12 col-md-4 col-lg-2 mb-6 mb-md-0">
      <div class="editor__avatar__wrapper">
        <BootstrapImage v-if="authorAvatar" class="editor__avatar__image" v-bind="authorAvatar"/>
      </div>
    </div>

    <div class="editor__meta col-12 col-md-8 col-lg-4 ps-md-4">

      <component class="editor__meta__name h2 mb-2" :is="nameTag">
        {{ editor.firstName }} {{ editor.lastName }}
      </component>

      <p class="text-ui-separator text-uppercase mb-1">
        {{ editor.position }}
      </p>

      <p class="fs-medium fw-bold">
        {{ editor.email }}
      </p>

      <div v-if="links" class="editor__meta-links">
        <a
          v-for="([key, value], index) in links"
          :href="value"
          :key="linkId(index)"
          class="link"
        >
          <template v-if="key === 'twitter'">
            <BootstrapIcon name="x" size="small" class="bg-black text-white rounded"/>
          </template>
          <template v-else>
            <BootstrapIcon :name="iconName(key)" size="small"/>
          </template>
        </a>
      </div>
    </div>

    <div v-if="editor.description && showAbout" class="col-12 col-lg-6 fs-medium fw-md-bold mb-0"
         v-html="editor.description"/>
    </div>
  `
    })
], Editor);
exports.Editor = Editor;
exports.default = Editor;
//# sourceMappingURL=Editor.js.map